import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { OnboardingHistoryService } from '../tokens/onboarding-history.token';
import { OnboardingStageHistoryEntry } from '../models/onboarding-history.model';

/**
 * REST-backed onboarding stage-history service.
 *
 * Calls GET /services/embedded/api/onboarding-application/{applicationId}/stage-history,
 * authenticated via the auth interceptor (KYC officer / underwriter / master-admin
 * bearer token). REST-only per Rule 07/10 — no mock fallback.
 */
@Injectable()
export class OnboardingHistoryRestService implements OnboardingHistoryService {
  private readonly http = inject(HttpClient);

  getStageHistory(applicationId: number): Observable<OnboardingStageHistoryEntry[]> {
    return this.http.get<OnboardingStageHistoryEntry[]>(
      `${API_PATHS.ONBOARDING_APPLICATION}/${applicationId}/stage-history`,
    );
  }
}
